import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {segmentReport_template} from "../components/templates/segmentReport_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class segmentReport extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected segmentReport_template: segmentReport_template;

    protected getModuleName(){
        return "segmentReport";
    }

    buildContent() : Array<Element>{

        this.segmentReport_template = new segmentReport_template( "segmentReport", this.viewModel, this );
        this.template = this.segmentReport_template;

        return [this.segmentReport_template.build()];
    }

    public fillPage() : void{
        this.segmentReport_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/segmentReport/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.segmentReport_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.segmentReport_template.builtTemplate);
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.segmentReport_template.setBrandFilterItems(responseParsed.brands);
        this.segmentReport_template.setAllBrandSegments(responseParsed.brandSegments);
        this.segmentReport_template.setBrandSegments(true);
        this.segmentReport_template.setViewModesItems();
        this.segmentReport_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.segmentReport_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.segmentReport_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.segmentReport_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.segmentReport_template.setPostContentTypesGroupFilterItems();
        this.segmentReport_template.setArticleTypesFilterItems();
        this.segmentReport_template.setDataRangesItems();
        this.segmentReport_template.setPublishStatusItems();
        this.segmentReport_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);
    }

    public getListData(): void{

        if (this.segmentReport_template.getTemplateViewModel().viewModeSelected() == "daily"){

            this.loadingIn(this.segmentReport_template.builtTemplate.children.namedItem("list-results"));
            this.segmentReport_template.activateGraphLoading();
            this.segmentReport_template.hideExportButton();

            let subViewModel = this.segmentReport_template.getViewModelForRequest();
            let baseApiUrl = '/api/segmentReport/get';

            this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListDataDaily');
        } else if (this.segmentReport_template.getTemplateViewModel().viewModeSelected() == "profitLoss"){

            this.loadingIn(this.segmentReport_template.builtTemplate.children.namedItem("list-pl-results"));
            this.segmentReport_template.hideExportButton();

            let subViewModel = this.segmentReport_template.getViewModelForRequest();
            let baseApiUrl = '/api/segmentReport/getPL';

            this.sendFilterCall(baseApiUrl, subViewModel, this.onPLDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListDataPl');
        }

    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.segmentReport_template.resetSelectedRows();
                obj.segmentReport_template.validationsList.clearMessages();

                obj.updateList(responseParsed.data);

                // LOADING : ends
                obj.loadingOut(obj.segmentReport_template.builtTemplate.children.namedItem("list-results"));
                obj.segmentReport_template.deactivateGraphLoading();
            });
        };
    }

    protected onPLDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.segmentReport_template.resetSelectedRows();
                obj.segmentReport_template.validationsList.clearMessages();

                obj.updateListPl(responseParsed.data.reportData);

                // LOADING : ends
                obj.loadingOut(obj.segmentReport_template.builtTemplate.children.namedItem("list-pl-results"));
            });
        };
    }

    protected updateList(responseParsed: any) {

        for (let item of responseParsed.reportData) {
            item.Day = this.formatDate(item.Day + "T12:00:00");
        }

        this.segmentReport_template.updateGraphData(responseParsed);
        this.segmentReport_template.setReportData(responseParsed);
    }

    protected updateListPl(plReportData: any) {

        this.segmentReport_template.setPlReportData(plReportData);
    }

    protected filterMultipleSelectorOnChange(){
        this.getListData();
    }

    protected filterDateOnChange(){
        this.getListData();
    }

    protected filterSimpleOnChange(){
        this.getListData();
    }

    public filterDropdownOnChange(){

        this.segmentReport_template.setBrandSegments(true);
        this.getListData();
    }

    private formatDate(date) {
        let weekday = new Array(7);
        weekday[0] = "Sun";
        weekday[1] = "Mon";
        weekday[2] = "Tue";
        weekday[3] = "Wed";
        weekday[4] = "Thu";
        weekday[5] = "Fri";
        weekday[6] = "Sat";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }

    public getCsvExportData(): void {

        let subViewModel = this.segmentReport_template.getViewModelForRequest();
        subViewModel["export"] = true;
        let usrReq_url = '/api/segmentReport/get';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCsvExportDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvExportDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                for (let item of response.data.reportData) {
                    item.Day = obj.formatDate(item.Day + "T12:00:00");
                }

                obj.segmentReport_template.setExportData(response.data);
            });
        }
    }

    public getCsvExportPlData(): void {

        let subViewModel = this.segmentReport_template.getViewModelForRequest();
        subViewModel["export"] = true;
        let usrReq_url = '/api/segmentReport/getPL';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetCsvExportPlDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetCsvExportPlDataReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.segmentReport_template.setExportPlData(responseParsed.data.reportData);
            });
        }
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url;
        let usrReq_callback;
        switch (id){

            case 'srEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteSrEditorsSuggestionsReturn;
                usrReq_url = '/api/emakiUsers/get/';
                break;
            }

            case 'jrEditorsFilter':{

                usrReq_callback = this.onGetMultipleAutoCompleteJrEditorsSuggestionsReturn;
                usrReq_url = '/api/emakiUsers/get/';
                break;
            }

            default :{

                usrReq_callback = this.onGetMultipleAutoCompleteCategoriesSuggestionsReturn;
                usrReq_url = '/api/emakiCategorySuggestions/';
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.segmentReport_template.validationsList.clearMessages();
                if(responseParsed.data){

                    obj.segmentReport_template.setSrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.segmentReport_template.deactivateLoading();
            });
        };
    }

    protected onGetMultipleAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.segmentReport_template.validationsList.clearMessages();
                if (responseParsed.data){

                    obj.segmentReport_template.setJrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.segmentReport_template.deactivateLoading();
            });
        };
    }

    protected onGetMultipleAutoCompleteCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.segmentReport_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.segmentReport_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.segmentReport_template.deactivateLoading();
            });
        }
    }


}



// WEBPACK FOOTER //
// ./js/modules/segmentReport.ts